import React from "react";
import ConnectToInternet from "../../reusable/ConnectToInternet";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
import AnyQuestions from "../../reusable/AnyQuestions";
import BlackTitleBar from "../getwifius/BlackTitleBar";
import GetSimSubNavi from "../../reusable/GetSimSubNavi";
import SimCartController from "./SimCart";
import SimCartBanner from "../../reusable/SimCartBanner";


class SimCart extends React.Component {
    render(){
        return(
            <div>
                <SimCartBanner />
                <GetSimSubNavi />
                <SimCartController />
                <AnyQuestions />
                <StayTouch />
            </div>
        );
    }
}

export default layoutWrapper(SimCart);



// WEBPACK FOOTER //
// ./src/pages/simCart/index.js